
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Sidebar extends Vue {
    setNav () {
        this.$store.commit('setSideNavFalse')
    }

    get radioSource () {
        return this.$store.getters['getRadioSource']
    }

    set radioSource (val: string) {
        this.setRadioSource(val)
    }

    setRadioSource(val: string) {
        this.$store.commit('setRadioSource', val)
        if (this.$store.getters['getRadio']) {
            this.$store.dispatch('startRadioPlayback').then((track) => {
                const audio = this.$store.getters['getAudio']
                if (track && audio) {
                    audio.play()
                }
            })
        }
    }
}
